import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// First-party visit counting for the owner's private /stats page
const API = process.env.REACT_APP_BACKEND_URL;
const flag = (k) => { try { return localStorage.getItem(k) === "1"; } catch { return false; } };
// live site only (preview/QA can force it with localStorage sb-analytics-debug=1); the owner's own browser is skipped
const enabled = () => !flag("sb-no-track") && !navigator.webdriver &&
  (window.location.hostname.endsWith("swolebears.ca") || flag("sb-analytics-debug"));

const uuid = () => (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);

const visitorId = () => {
  let v = localStorage.getItem("sb-vid");
  if (!v) { v = uuid(); localStorage.setItem("sb-vid", v); }
  return v;
};

// a session ends after 30 minutes without activity; returns [id, isNew]
const sessionId = () => {
  const now = Date.now();
  let s = null;
  try { s = JSON.parse(sessionStorage.getItem("sb-sid")); } catch { s = null; }
  const fresh = !s || now - s.at > 30 * 60 * 1000;
  const id = fresh ? uuid() : s.id;
  sessionStorage.setItem("sb-sid", JSON.stringify({ id, at: now }));
  return [id, fresh];
};

export const track = (type) => {
  if (!API || !enabled()) return;
  try {
    const [sid, fresh] = sessionId();
    const utm = new URLSearchParams(window.location.search).get("utm_source") || "";
    const body = {
      type, path: window.location.pathname.slice(0, 200), vid: visitorId(), sid, mobile: window.innerWidth < 768,
      ref: fresh ? document.referrer.slice(0, 500) : "", utm: fresh ? utm.slice(0, 100) : "",
    };
    fetch(`${API}/api/track`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body), keepalive: true }).catch(() => {});
  } catch {
    // storage blocked (private mode etc.): skip silently
  }
};

export const VisitTracker = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/stats")) return undefined;
    const t = setTimeout(() => track("view"), 300);
    return () => clearTimeout(t);
  }, [pathname]);
  return null;
};
